// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form___7H3G"};